
import { Component, Prop, Vue } from "vue-property-decorator";
import EkomiStars from './ekomi-stars.vue';

@Component({ components: { EkomiStars } })
export default class HighlightMarker extends Vue {
  @Prop() active!: boolean;
  @Prop() sliderEnabled!: boolean;
  @Prop() ekomiId!: number;

  @Prop({ required: true })
  activeIcon!: string;
  @Prop({ required: true })
  inactiveIcon!: string;
  @Prop({ required: true })
  sliderWidth!: number;
  @Prop({ required: true })
  src!: string;
  @Prop({ required: true })
  headline!: string;

  @Prop({ required: true })
  content!: string;
  @Prop({ default: 0, type: Number })
  contentOffsetTop!: number;
  @Prop({ default: 0, type: Number })
  contentOffsetBottom!: number;

  isActive = false;

  defaultZIndex!: number;

  iconActiveWidth!: number;
  iconActiveHeight!: number;
  iconInactiveWidth!: number;
  iconInactiveHeight!: number;

  width = 0;
  height = 0;

  timeout!: number | null;

  $refs!: {
    marker: HTMLDivElement;
    slider: HTMLDivElement;
    content: HTMLDivElement;
  };

  mounted() {
    const [iconActiveWidth, iconActiveHeight] = this.activeIcon.split("x");
    this.iconActiveWidth = parseInt(iconActiveWidth, 10);
    this.iconActiveHeight = parseInt(iconActiveHeight, 10);

    const [iconInactiveWidth, iconInactiveHeight] = this.inactiveIcon.split(
      "x"
    );
    this.iconInactiveWidth = parseInt(iconInactiveWidth, 10);
    this.iconInactiveHeight = parseInt(iconInactiveHeight, 10);

    if (this.active) {
      this.width = this.iconActiveWidth;
      this.height = this.iconActiveHeight;
    } else {
      this.width = this.iconInactiveWidth;
      this.height = this.iconInactiveHeight;
    }
  }

  onFocus() {
    if (this.active) return;
    if (this.timeout) {
      clearTimeout(this.timeout);
      this.timeout = null;
    }
    this.width = this.iconActiveWidth;
    this.height = this.iconActiveHeight;

    if (
      this.$refs.marker.parentElement &&
      this.$refs.marker.parentElement.parentElement
    ) {
      if (!this.defaultZIndex) {
        this.defaultZIndex = parseInt(this.$refs.marker.parentElement.parentElement.style.zIndex, 10);
      }
      this.$refs.marker.parentElement.parentElement.style.zIndex = (this.defaultZIndex + 500).toString();
    }
    this.$refs.marker.classList.add('visible');
    this.timeout = window.setTimeout(() => (this.isActive = true), 200);
  }

  onBlur() {
    if (this.active) return;
    if (this.timeout) {
      clearTimeout(this.timeout);
      this.timeout = null;
    }
    this.isActive = false;

    // wait for slider folding back in until minimizing the marker size.
    setTimeout(() => {
      this.width = this.iconInactiveWidth;
      this.height = this.iconInactiveHeight;
      if (
        this.$refs.marker.parentElement &&
        this.$refs.marker.parentElement.parentElement
      ) {
        if (!this.defaultZIndex) {
          this.defaultZIndex = parseInt(this.$refs.marker.parentElement.parentElement.style.zIndex, 10);
        }
        this.$refs.marker.parentElement.parentElement.style.zIndex = this.defaultZIndex.toString();
      }
      this.$refs.marker.classList.add('visible');
    }, 200);
  }

  markerStyle() {
    return {
      width: this.sliderWidth + "px",
      minHeight: this.iconActiveHeight + "px",
    };
  }

  iconStyle() {
    return {
      width: this.width + "px",
      height: this.height + "px",
      zIndex: 1,
    };
  }

  figureStyle() {
    return {
      borderRadius: (this.iconActiveWidth + 5) / 2 + "px",
      width: this.iconActiveWidth + 'px',
      height: this.iconActiveHeight + 'px',
    };
  }

  calcBottomLeftRadius(height: string): string {
    let borderBottomLeftRadius: string = this.iconActiveHeight / 2 + "px";
    if (this.$refs.slider) {
      const sliderStyle = window.getComputedStyle(this.$refs.slider);
      const sliderHeight = parseInt(sliderStyle.height || height, 10);
      if (sliderHeight > this.iconActiveHeight) {
        borderBottomLeftRadius = "0";
      }
    }
    return borderBottomLeftRadius;
  }

  convertAndSum(...nums: (string | number | null)[]) {
    return nums
      .map(n => null !== n ? parseInt((n || '0').toString(), 10) : 0)
      .reduce((s, n) => s + n, 0);
  }

  sliderStyle() {
    return {
      width: this.sliderWidth + "px",
      marginLeft: `calc(${this.iconActiveWidth}px / 2)`,
      paddingTop: `0`,
    };
  }

  contentStyle() {
    let minHeight = this.iconActiveHeight;

    const result: any = {
      transform: `translate3d(-${this.sliderWidth}px, 0, 0)`,
      paddingLeft: `calc(${this.iconActiveWidth}px / 2)`,
      width: this.sliderWidth + "px",
    };

    if (this.contentOffsetTop > 0) {
      result.marginTop = this.contentOffsetTop + 'px';
      minHeight -= this.contentOffsetTop;
    }
    if (this.contentOffsetBottom > 0) {
      result.marginBottom = this.contentOffsetBottom + 'px';
      minHeight -= this.contentOffsetBottom;
    }
    result.minHeight = minHeight + 'px';

    return result;
  }
}
